import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        level: '='
    },
    template: `
        <h1>{{ 'user.Add level' | translate }}</h1>
        <user-group-form-level form="vm.form" level="vm.level"/>
`
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.create(this.level, model => model.$save());
    }
}




// WEBPACK FOOTER //
// ./src/app/components/user/group/add/level/index.js